var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThLarge = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.046 2h5.115c1.13 0 2.046 0.916 2.046 2.046v5.115c0 1.13-0.916 2.046-2.046 2.046h-5.115c-1.13 0-2.046-0.916-2.046-2.046v-5.115c0-1.13 0.916-2.046 2.046-2.046z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.046 12.855h5.115c1.13 0 2.046 0.916 2.046 2.046v5.115c0 1.13-0.916 2.046-2.046 2.046h-5.115c-1.13 0-2.046-0.916-2.046-2.046v-5.115c0-1.13 0.916-2.046 2.046-2.046z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.839 2h5.115c1.13 0 2.046 0.916 2.046 2.046v5.115c0 1.13-0.916 2.046-2.046 2.046h-5.115c-1.13 0-2.046-0.916-2.046-2.046v-5.115c0-1.13 0.916-2.046 2.046-2.046z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.839 12.855h5.115c1.13 0 2.046 0.916 2.046 2.046v5.115c0 1.13-0.916 2.046-2.046 2.046h-5.115c-1.13 0-2.046-0.916-2.046-2.046v-5.115c0-1.13 0.916-2.046 2.046-2.046z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThLarge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/th-large.3343ec19.svg";
export { ForwardRef as ReactComponent };